import { CheckCircle2 } from "lucide-react";
import { FORM } from "./content";

export const FormSuccess = ({ onReset }) => (
    <div
        data-testid="hire-form-success"
        role="status"
        className="mt-12 md:mt-16 max-w-2xl mx-auto rounded-3xl border border-hire-line bg-white p-8 md:p-12 text-center shadow-[0_30px_80px_-50px_rgba(11,15,25,0.25)]"
    >
        <div className="mx-auto h-16 w-16 rounded-full bg-brand-blue-soft grid place-items-center">
            <CheckCircle2 className="h-8 w-8 text-brand-blue" />
        </div>
        <h3 className="mt-6 font-bold text-[28px] md:text-[34px] text-hire-ink">
            {FORM.successTitle}
        </h3>
        <p className="mt-4 text-base md:text-lg text-hire-muted leading-relaxed">
            {FORM.successMessage}
        </p>
        <div className="mt-8 grid grid-cols-3 gap-3 text-left">
            {[
                ["1", "We review your requirements"],
                ["2", "We connect to clarify the role"],
                ["3", "Shortlist in 5–7 days"],
            ].map(([n, t]) => (
                <div key={n} className="rounded-xl bg-hire-bg border border-hire-line p-3">
                    <p className="text-[11px] font-bold text-brand-blue">Step {n}</p>
                    <p className="mt-1 text-[13px] font-medium text-hire-ink leading-snug">{t}</p>
                </div>
            ))}
        </div>
        <button
            type="button"
            data-testid="hire-form-reset"
            onClick={onReset}
            className="mt-8 text-sm text-hire-muted hover:text-hire-ink underline underline-offset-4 transition-colors"
        >
            Submit another request
        </button>
    </div>
);

export default FormSuccess;
